import React, { useContext } from "react";

/// React router dom
import { Outlet, Route, Routes } from "react-router-dom";

/// Css
import "./chart.css";
import "./index.css";
import "./step.css";

/// Layout
import Footer from "./layouts/Footer";
import Nav from "./layouts/nav";
import NavAffiliate from './layouts/NavAffiliate';

import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import Home from "./components/Dashboard/Home";

//Affiliate
import AffiliateDashboard from "./pages/afiliado/dashboard";
import EditAfiliado from "./pages/afiliado/editAfiliado";

//USERS
import UserManagement from "./pages/users/UserManagement";

//Crypto
// import CoinDetails from "./components/Crypto/CoinDetails";

//Report

/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import EditProfile from "./components/AppsMenu/AppProfile/EditProfile";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";

/// Product List

/// Charts
//import Chartist from "./components/charts/chartist";

/// Bootstrap

/// Plugins

//Redux
//import Todo from "./pages/Todo";

// Widget

/// Table
import BootstrapTable from "./components/table/BootstrapTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import SortingTable from "./components/table/SortingTable/SortingTable";

/// Form
import UiPagination from "./components/bootstrap/Pagination.js";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Element from "./components/Forms/Element/Element";
import FormValidation from "./components/Forms/FormValidation/FormValidation";
import Pickers from "./components/Forms/Pickers/Pickers";
import Wizard from "./components/Forms/Wizard/Wizard";


import Activity from "./components/Report/Activity";
import Contact from "./components/Report/Contact";
import History from "./components/Report/History";
import Order from "./components/Report/Order";
import Reports from "./components/Report/Reports";

import Customers from "./components/AppsMenu/Shop/Customers/Customers";


/// Pages
//import Registration from "./pages/Registration";
//import Login from "./pages/Login";
//import ForgotPassword from "./pages/ForgotPassword";
import { ThemeContext } from "../context/ThemeContext";
import ManagementPanel from "./components/Dashboard/Dashboard/ManagementPanel";
import CompanyView from "./pages/company/CompanyView";
import OwnInvoiceManagement from "./pages/company/OwnInvoiceManagement";
import AllEmployees from "./pages/employee/AllEmployees";
import EmployeeView from "./pages/employee/EmployeeView";
import AllInvoices from "./pages/invoices/AllInvoices";


import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import LockScreen from "./pages/LockScreen";
import MonthlyInterest from "./pages/mora/MonthlyInterest";
import Profile from "./pages/profile/Profile";

const Markup = () => {
  const allroutes = [
    /// Dashboard
    { url: "", component: <Home /> },
    { url: "dashboard", component: <Home /> },
    { url: "employee-management", component: <EmployeeView /> },
    { url: "invoice-management", component: <CompanyView /> },
    { url: "own-invoice-management", component: <OwnInvoiceManagement /> },
    { url: "profile", component: <Profile /> },
    { url: "business-control-panel", component: <ManagementPanel /> },
    { url: "all-employees", component: <AllEmployees /> },
    { url: "listado-facturas", component: <AllInvoices /> },
    { url: "interes", component: <MonthlyInterest /> },
    { url: "interes", component: <MonthlyInterest /> },
    { url: "usuarios-empresas", component : <UserManagement />},

    //Trading
    // { url: "market", component: <Market /> },
    // { url: "ico-listing", component: <IcoListing /> },
    // { url: "p2p", component: <P2P /> },
    // { url: "future", component: <Future /> },
    // { url: "intraday-trading", component: <IntradayTrading /> },

    // //Crypto
    // { url: "crypto", component: <MarketWatch /> },
    // { url: "ico-listing-filter", component: <IcoListingFilter /> },
    // { url: "banking", component: <Banking /> },
    // // { url: "exchange", component: <Exchange /> },
    // // { url: "coin-details", component: <CoinDetails /> },

    // //Report
    { url: "history", component: <History /> },
    { url: "orders", component: <Order /> },
    { url: "reports", component: <Reports /> },
    { url: "contact", component: <Contact /> },
    { url: "activity", component: <Activity /> },
    /////Demo

    /// Apps
    { url: "app-profile", component: <AppProfile /> },
    { url: "edit-profile", component: <EditProfile /> },
    { url: "email-compose", component: <Compose /> },
    { url: "email-inbox", component: <Inbox /> },
    { url: "email-read", component: <Read /> },
    { url: "app-calender", component: <Calendar /> },
    { url: "post-details", component: <PostDetails /> },

    //afiliado
    { url: "afiliado", component: <AffiliateDashboard /> },
    { url: "/afiliado/edit-afiliado", component: <EditAfiliado /> },

    /// Shop
    // { url: "ecom-product-grid", component: <ProductGrid /> },
    // { url: "ecom-product-list", component: <ProductList /> },
    // { url: "ecom-product-detail", component: <ProductDetail /> },
    // { url: "ecom-product-order", component: <ProductOrder /> },
    // { url: "ecom-checkout", component: <Checkout /> },
    // { url: "ecom-invoice", component: <Invoice /> },
     { url: "ecom-customers", component: <Customers /> },
    // //
    // ///// Chart
    // { url: "chart-sparkline", component: <SparklineChart /> },
    // { url: "chart-chartjs", component: <ChartJs /> },
    // { url: "chart-apexchart", component: <ApexChart /> },
    // { url: "chart-rechart", component: <RechartJs /> },
    // //
    // ///// Bootstrap
    // { url: "ui-alert", component: <UiAlert /> },
    // { url: "ui-badge", component: <UiBadge /> },
    // { url: "ui-button", component: <UiButton /> },
    // { url: "ui-modal", component: <UiModal /> },
    // { url: "ui-button-group", component: <UiButtonGroup /> },
    // { url: "ui-accordion", component: <UiAccordion /> },
    // { url: "ui-list-group", component: <UiListGroup /> },
    // { url: "ui-card", component: <UiCards /> },
    // { url: "ui-carousel", component: <UiCarousel /> },
    // { url: "ui-dropdown", component: <UiDropDown /> },
    // { url: "ui-popover", component: <UiPopOver /> },
    // { url: "ui-progressbar", component: <UiProgressBar /> },
    // { url: "ui-tab", component: <UiTab /> },
     { url: "ui-pagination", component: <UiPagination /> },
    // { url: "ui-typography", component: <UiTypography /> },
    // { url: "ui-grid", component: <UiGrid /> },
    // //
    // ///// Plugin
    // { url: "uc-select2", component: <Select2 /> },
    // { url: "uc-noui-slider", component: <MainNouiSlider /> },
    // { url: "uc-sweetalert", component: <MainSweetAlert /> },
    // { url: "uc-toastr", component: <Toastr /> },
    // { url: "map-jqvmap", component: <JqvMap /> },
    // { url: "uc-lightgallery", component: <Lightgallery /> },
    //
    /////Redux
    //{ url: "todo", component: Todo },
    //
    ///// Widget
   // { url: "widget-basic", component: <Widget /> },

    ///// Form
    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },
    //
    ///// table
    { url: "table-filtering", component: <FilteringTable /> },
    { url: "table-sorting", component: <SortingTable /> },
    { url: "table-bootstrap-basic", component: <BootstrapTable /> },
  ];

  const isAffiliate = localStorage.getItem("userDetailsAfiliate") !== null;

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route path="afiliarme" element={<nuevoAfiliado />} />
        <Route element={isAffiliate ? <AfiliateMenu /> : <MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle } = useContext(ThemeContext);
  return (
    <div
      id="main-wrapper"
      className={`show ${!menuToggle ? "menu-toggle" : ""}`}
    >
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}
function AfiliateMenu() {
  const { menuToggle } = useContext(ThemeContext);
  return (
    <div
      id="main-wrapper"
      className={`show ${!menuToggle ? "menu-toggle" : ""}`}
    >
      <NavAffiliate />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Markup;
